export default __webpack_public_path__ + "static/media/plum.34305d6f.png";